import { FormikProps } from 'formik';
import React from 'react';

import { Input } from '../../../../../ui';
import { ProfileFormValues } from '../EditModal';

export function TitleField({ values, setFieldValue }: FormikProps<ProfileFormValues>) {
    return (
        <Input
            label="Title"
            name="title"
            id="title"
            type="text"
            value={values.title}
            onChange={({ currentTarget }) => {
                setFieldValue('title', currentTarget.value);
            }}
            placeholder="Dr"
        />
    );
}
